<div class="RetryErrorModal">
  <div class="RetryErrorModal-content">
    <img src="assets/images/alert/warningAlert2.svg" alt="warning" class="warning-icon" />
    <p class="title">{{ 'retryErrorModal.title' | translate }}</p>
    <p class="subtitle">{{ 'retryErrorModal.subtitle' | translate }}</p>
    <div class="actions">
      <button class="btn-cancel" (click)="onCancel()">
        {{ 'retryErrorModal.cancel' | translate }}
      </button>
      <button class="btn-retry" (click)="onRetry()">
        <img src="assets/images/reloadPassport.svg" alt="retry" class="retry-icon" />
        {{ 'retryErrorModal.retry' | translate }}
      </button>
    </div>
  </div>
</div>
